import React, { useEffect, useState } from 'react'
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    TablePagination,
    Box,
    Grid,
    Typography
} from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { ApiDeleteStarRatingData, ApiGetStarRatingData } from '../../../apiService/Core/Apicall.tsx'


const StarRating: React.FC = () => {
    const [starRating, setStarRating] = useState<any[]>([])
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [datalength, setdatalength] = useState<any>(null);


    const navigate = useNavigate();

    //   const handleDeletestarRating = async (id: number) => {
    //     try {
    //       toast.success('starRating deleted successfully')
    //     } catch (error) {
    //       console.error('Error deleting starRating:', error)
    //       toast.error('Failed to delete starRating')
    //     }
    //   }


    //   useEffect(() => {
    //     const fetchData = async () => {
    //       await handleApiGetstarRatingJson()
    //     }
    //     fetchData()
    //     return () => { }
    //   }, [page, rowsPerPage])

    //   const handleApiGetstarRatingJson = async () => {
    //     const data = `?offset=${rowsPerPage * page}&limit=${rowsPerPage}`;
    //     try {
    //       const res = await ApiGetstarRatingJson(data)
    //       setdatalength(res.totalCount)
    //       setStarRating(res.data)
    //     } catch (error) {
    //       console.error('Error deleting starRating:', error)
    //     }
    //   }
    //   // ------------------------------------------- Chnage Pagination -----------------------------------------------
    const handleChangePage = (_event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const handleGetStarRating = async () => {
        try {
            const res = await ApiGetStarRatingData(`?offset=${page * rowsPerPage}&limit=${rowsPerPage}`)
            setStarRating(res?.data)
            setdatalength(res?.total);
        } catch (error) {
            toast.error("Error Generating Star Rating.")
            console.error("Error Generating Star Rating.", error);
        }
    }
    useEffect(() => {
        handleGetStarRating()
    }, [page, rowsPerPage]);

    const handleDeletestarRating = async (id: any) => {
        try {
            const res = await ApiDeleteStarRatingData(`?starRatingId=${id}`)
            toast.success(res.message);
            handleGetStarRating();
        } catch (error) {
            toast.error("Error Deleting Star Rating.")
            console.error("Error Deleting Star Rating.", error);
        }
    }
    return (
        <div className='w-100 p-2'>
            <Box className='w-100 bg-white p-2 py-3 border-10'>
                <Grid className='mt-3 mb-4 align-items-center' gap={2} container>
                    {/* REPORT OVERVIEW PROMPTS */}
                    <Grid size={{ xs: 12, md: "grow" }}>
                        <Typography className='fs-42 text-center'>Star Rating</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, md: "auto" }}>
                        <div className='d-flex justify-content-end'>
                            <Link
                                to={`/admin/others/add/star-rating`}
                                // onClick={() => { navigate('/admin/others/add/star-rating') }}
                                className='table-row-background link-btn'
                            >
                                Create Star Rating
                            </Link>
                        </div>{' '}
                    </Grid>
                </Grid>
                {/* <TableContainer component={Paper}> */}
                <Box className='w-100' overflow={'auto'}>
                    <Table>
                        <TableHead>
                            <TableRow className='table-row-background'>
                                {['Star Rating', 'Delete'].map(
                                    items => (
                                        <TableCell className='tableCell-header' sx={{ width: `${100 / 2}%`, textAlign: 'center' }}>{items}</TableCell>
                                    )
                                )}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {starRating.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={3} align="center" sx={{ py: 3, fontWeight: "bold" }}>
                                        No Star Rating Found
                                    </TableCell>
                                </TableRow>
                            ) : (
                                starRating.map((starRating) => (
                                    <TableRow key={starRating.starRatingId}>
                                        <TableCell sx={{ width: "33%", textAlign: "center" }}>
                                            {starRating.starRatingDesc}
                                        </TableCell>
                                        <TableCell sx={{ width: "33%", textAlign: "center" }}>
                                            <Button
                                                variant="contained"
                                                className="delete-transparent"
                                                onClick={() => handleDeletestarRating(starRating.starRatingId)}
                                            >
                                                <DeleteIcon className="delete-icon" />
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </Box>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    component="div"
                    count={datalength}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
                {/* </TableContainer> */}
            </Box>
        </div>
    )
}

export default StarRating;
